import React from "react";
import { useLocation } from "react-router";
import Instrument from "../components/instrument/Instrument";
import Sidebar from "../components/sidebar/Sidebar";

// InstrumentPage component renders the instrument interface with a sidebar and instrument content.
// It receives an openDrawer prop to control the sidebar drawer and extracts user data from the location state.
const InstrumentPage = ({ openDrawer }) => {
  // useLocation hook provides access to the location object, which contains the state passed through navigation.
  const location = useLocation();

  // UserData object extracts user-specific data from the location state for rendering and authentication purposes.
  const UserData = {
    roles: location.state?.roles, // User roles (e.g., admin, user)
    isAdmin: location.state?.isAdmin, // Boolean flag indicating if the user is an admin
    isAuthenticated: location.state?.isAuthenticated, // Boolean flag indicating if the user is authenticated
    refreshToken: location.state?.refreshToken, // Token used to refresh user session
    accessToken: location.state?.accessToken, // Token used for API requests
    userId: location.state?.userId, // Unique identifier for the user
    username: location.state?.username, // Username of the authenticated user
  };

  return (
    <>
      {/* Sidebar component with openDrawer and userData props. 
          The 'active' prop indicates the active menu item in the sidebar (6 in this case). */}
      <Sidebar openDrawer={openDrawer} userData={UserData} active={4} />

      {/* Instrument component that renders the main content for the instrument page. 
          It receives the openDrawer and userData props. */}
      <Instrument openDrawer={openDrawer} userData={UserData} />
    </>
  );
};

export default InstrumentPage;
